import { render } from "./MainAsideMenu.vue?vue&type=template&id=3edfe52c"
import script from "./MainAsideMenu.vue?vue&type=script&lang=js"
export * from "./MainAsideMenu.vue?vue&type=script&lang=js"

import "./MainAsideMenu.vue?vue&type=style&index=0&id=3edfe52c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__